import React, {FC} from 'react';
import cls from './PlayPauseButton.module.scss';
import playIcon from '../../../../../../assets/icons/playIcon.svg';
import pauseIcon from '../../../../../../assets/icons/pauseIcon.svg';

interface PlayPauseButtonProps {
    className?: string;
    onPlayPause: () => void;
    playing: boolean;
}

export const PlayPauseButton: FC<PlayPauseButtonProps> = ({onPlayPause, playing}) => {
    return (
        <button className={cls.button} onClick={onPlayPause}>
            {
                playing
                    ? <img src={pauseIcon} alt="pause"/>
                    : <img src={playIcon} alt="play"/>
            }
        </button>
    );
}
